import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import healthcare from "../../../Assets/Projects/GIS/Labucare.png";
import healthcare2 from "../../../Assets/Projects/GIS/Labucare2.png";
import healthcare3 from "../../../Assets/Projects/GIS/Labucare3.png";
import healthcare4 from "../../../Assets/Projects/GIS/Labucare4.png";
import healthcare5 from "../../../Assets/Projects/GIS/Labucare5.png";
import healthcare6 from "../../../Assets/Projects/GIS/Labucare6.png";


function HealthcareRoute() {
  return (
    <ProjectDetailCard
      title="Healthcare Route Optimization System"
      image={healthcare}
      screenshots={[healthcare2, healthcare3, healthcare5]}
      description="
      Healthcare Route Optimization System is a Geographic Information System (GIS) developed to help users identify the fastest route to healthcare facilities in North Labuhanbatu Regency. The application integrates ArcGIS technology with interactive digital maps to visualize healthcare locations, calculate optimal travel routes, and provide accurate navigation information. Designed with a user-friendly interface, the system improves accessibility to healthcare services while supporting efficient decision-making during emergency and routine healthcare visits.
      "
      technologies={[
        "ArcGIS",
        "Leaflet",
        "ArcGIS API for JavaScript",
        "JavaScript",
        "Bootstrap 5",
        "CodeIgniter 4",
        "PHP",
        "Python",
        "GIS",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={healthcare4} alt="gallery1" />
          <img src={healthcare6} alt="gallery2" />
          <img src={healthcare} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default HealthcareRoute;
